import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { YoutubeLiveCounterV1 } from './v1/YoutubeLiveCounterV1';
import { YoutubeLiveCounterV2 } from './v2/YoutubeLiveCounterV2';

/**
 * Picks logger (v1) vs BFF self endpoint (v2) from GrowthBook; each branch owns its own data hook.
 */
export function YoutubeLiveCounter() {
  const useYoutubeStatsV2 = useFeatureIsOn('app__youtube_stats_use_v2_api');
  return useYoutubeStatsV2 ? <YoutubeLiveCounterV2 /> : <YoutubeLiveCounterV1 />;
}
